module.exports = __webpack_public_path__ + "static/img/14000676.2e9c9bc5.png";